const DECIMAL_LIMIT_MESSAGE = "Informe no máximo 22 dígitos inteiros e 8 casas decimais."
const DECIMAL_FORMAT_MESSAGE = "Informe um número decimal válido."
const DECIMAL_INCOMPLETE_MESSAGE = "Conclua o valor ou limpe o campo."
const DECIMAL_PATTERN = /^-?\d{1,22}(?:[,.]\d{1,8})?$/
const INCOMPLETE_DECIMAL_PATTERN = /^-?(?:\d+)?[,.]$/

export const getDecimalValidationMessage = (value, {allowNegative = true} = {}) => {
    const decimalValue = String(value ?? "")

    if (decimalValue === "") {
        return ""
    }

    if (decimalValue === "-" || INCOMPLETE_DECIMAL_PATTERN.test(decimalValue)) {
        return DECIMAL_INCOMPLETE_MESSAGE
    }

    if (!DECIMAL_PATTERN.test(decimalValue)) {
        const [integerPart, decimalPart] = decimalValue.replace(/^-/, "").split(/[,.]/)

        if (integerPart.length > 22 || decimalPart?.length > 8) {
            return DECIMAL_LIMIT_MESSAGE
        }

        return DECIMAL_FORMAT_MESSAGE
    }

    if (!allowNegative && decimalValue.startsWith("-")) {
        return "Informe um valor maior ou igual a zero."
    }

    return ""
}

const isCompleteOptionalDecimal = (value, options) => !getDecimalValidationMessage(value, options)

export const isValidationParametersReady = ({
    dataReferencia,
    puparReferencia,
    pumtmReferencia,
    spreadCredito,
} = {}) => (
    Boolean(dataReferencia)
    && isCompleteOptionalDecimal(puparReferencia, {allowNegative: false})
    && isCompleteOptionalDecimal(pumtmReferencia, {allowNegative: false})
    && isCompleteOptionalDecimal(spreadCredito)
)
